import { render, staticRenderFns } from "./request-responder.vue?vue&type=template&id=5ba404a6&scoped=true"
import script from "./request-responder.vue?vue&type=script&lang=ts"
export * from "./request-responder.vue?vue&type=script&lang=ts"
import style0 from "./request-responder.vue?vue&type=style&index=0&id=5ba404a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba404a6",
  null
  
)

export default component.exports